import {
  ActivityInterface,
  ActivityLogParamsInterface,
} from '../../interfaces/manage-activity-logs.interface';
import {
  ActivityCategoryFilter,
  ActivityFeatureFilter,
  ActivityLogFilterInterface,
  ActivityMessageFilter,
  ActivitySurveyStatusFilter,
  ActivityTimeFilter,
  ActivityUserFilter,
  ActivityUserTypeFilter,
} from './activity-log-filters';

type ParamsKey = keyof ActivityLogParamsInterface;

export class ActivityLogFilterHandler {
  constructor(public readonly params: ActivityLogParamsInterface = {}) {}

  public filter(logs: ActivityInterface[] = []): ActivityInterface[] {
    const filters = this.buildFilters(this.params);

    const paramKeys = Object.keys(this.params) as ParamsKey[];
    return paramKeys
      .map((key) => filters[key])
      .map((param) => param())
      .reduce((acc, next) => next.filter(acc), logs);
  }

  private buildFilters(
    params: ActivityLogParamsInterface
  ): Record<ParamsKey, () => ActivityLogFilterInterface> {
    return {
      category: () => new ActivityCategoryFilter(params.category),
      feature: () => new ActivityFeatureFilter(params.feature),
      message: () => new ActivityMessageFilter(params.message),
      surveyStatus: () => new ActivitySurveyStatusFilter(params.surveyStatus),
      user: () => new ActivityUserFilter(params.user),
      userType: () => new ActivityUserTypeFilter(params.userType),
      startDate: () => ActivityTimeFilter.start(params.startDate),
      endDate: () => ActivityTimeFilter.end(params.endDate),
    };
  }
}
